export default __webpack_public_path__ + "static/media/ag.2e2cdf2a.svg";